module.exports = __webpack_public_path__ + "ef54be3e0da64feb10ce42bb0445bd87.jpg";